import { initSwiper } from "../submodules/swp-carousel";

// Legacy - Multicorporate project

function filterCarousel() {
  function elementControl(element, value, slide) {
    if (slide.querySelector(element)) {
      const truncateWords = slide.querySelector(element).dataset.truncatewords;
      if (truncateWords) {
        let truncatedValue = value.split(' ').slice(0, truncateWords);
        value = value.length > truncateWords
              ? `${truncatedValue.join(' ')}…`
              : value
      }

      value
        ? slide.querySelector(element).innerHTML = value
        : slide.querySelector(element).remove()
    }
  }

  function imageControl(element, value, slide) {
    if (slide.querySelector(element)) {
      value
        ? slide.querySelector(element).src = value
        : slide.querySelector(element).remove()
    }
  }

  function linkControl(element, value, slide) {
    if (slide.querySelector(element)) {
      value
        ? slide.querySelector(element).href = value
        : slide.querySelector(element).remove()
    }
  }

  function modalControl(element, value, slide) {
    if (slide.querySelector(element)) {
      value
        ? slide.querySelector(element).dataset.target = value
        : slide.querySelector(element).remove()
    }
  }

  function updateBookingButton(element, value, slide) {
    let button = slide.querySelector(element);

        if (button) {
          button.classList.remove("js-reveal-offer")
          const now = new Date().toLocaleDateString('es-ES', {
            day: "numeric",
            month: "2-digit",
            year: "numeric"
          });

          const hotel_name = value.hotel_name != null
                            ? value.hotel_name
                            : value.title;
          const hotel_code = value.hotel_code != null
                            ? value.hotel_code
                            : value.destination_code;
          const from_data = value.from_data != null
                            ? value.from_data
                            : false;
          const to_data = value.to_data != null
                          ? value.to_data
                          : '';

          button.dataset.desde = from_data ? from_data : now;
          button.dataset.hasta = to_data ? to_data : '';
          button.dataset.oferta = value.title;
          button.dataset.hotel = hotel_name
                                  ? hotel_name
                                  : '';
          button.dataset.hotelCod = hotel_code
                                  ? hotel_code
                                  : '';
          button.dataset.codigo = value.code;

          button.dataset.type = value.type != null
                                ? value.type
                                : '';

          button.dataset.url = value.url_bookcore != null
                                ? value.url_bookcore
                                : '';

          button.dataset.minimoNoches = value.min_nights != null
                                ? value.min_nights
                                : '';

          if (button.dataset.paquete) {
            // packages
            if (button.dataset.url) {
              button.addEventListener('click', function (event) {
                event.preventDefault();
                window.location.href = button.dataset.url;
              });
            } else {
              button.addEventListener('click', function(){
                  RoiEngineWidget.createPackageModal(this);
              });
            }
          } else if(button.dataset.codigo && button.dataset.oferta){
            // offers
            button.addEventListener('click', function(){
                RoiEngineWidget.createOfferModal(this);
            })
          } else if(button.dataset.codigo || button.dataset.hotelCod) {
            // hotels or rooms
            button.addEventListener('click', function(){
                RoiEngineWidget.createRoomModal(this);
            })
          }
        }
      }

  function navigationControl(carouselItems, element) {
    let config = JSON.parse(element.dataset.swpCarouselConfig);
    const arrows = element.parentNode.querySelector(".js-swiper-arrows");
    config.itemsLenght = carouselItems.length;
    if (config.itemsVisibleSm > config.itemsVisibleLg) {
      config.itemsVisibleSm = config.itemsVisibleLg;
    }
    element.dataset.swpCarouselConfig = JSON.stringify(config);
    if (arrows) {
      config.itemsLenght > config.itemsVisibleLg
        ? arrows.classList.remove("hidden-lg")
        : arrows.classList.add("hidden-lg")
    }
  }

  function sortCarousel(carouselItems, element,  swp_slide, swp_wrap) {

    if(carouselInstance) {
      carouselInstance.destroy(true, true);
    }
    swp_wrap.innerHTML = '';

    carouselItems = carouselItems.length == 1 && carouselItems[0].hotels != null
      ? carouselItems[0].hotels
      : carouselItems

    carouselItems.forEach(function (el) {
      createCard(el, swp_slide, swp_wrap);
    });

    element.classList.add("js-swpCarousel");

    navigationControl(carouselItems, element);
    initSwiper(element);

    var carouselInstance = Swiper;
  }

  function createCard(el, swp_slide, swp_wrap) {

    let slide = document.createElement("div");
    slide.classList.add("swiper-slide");
    slide.innerHTML = swp_slide;
    swp_wrap.appendChild(slide);
    elementControl(".js-title", el.title, slide);
    elementControl(".js-subtitle", el.subtitle, slide);
    el.text = el.text.replace(/(?:\r\n|\r|\n)/g, '<br>')
    elementControl(".js-paragraph", el.text , slide);
    imageControl(".js-img--image", el.images, slide);
    if (el.modal_target) {
      modalControl(".js-sd-modal__button", el.modal_target, slide);
    } else {
      linkControl(".js-cta", el.url, slide);
    }
    elementControl(".js-price-from", el.from_price, slide);
    elementControl(".js-price-currency", el.currency, slide);
    if (!el.from_price) {
      if (slide.querySelector(".js-actions-from")) {
        slide.querySelector(".js-actions-from").remove();
      }
    }
    updateBookingButton(".js-booking-button", el, slide);
  }

  function initFilterCarousel (element) {
    if (element) {
      const moduleWrap = element.parentNode.parentNode.parentNode
      const filters = moduleWrap.querySelectorAll('.js-carousel-filter');
      let swpSlide = element.querySelector(".swiper-slide");
      let swpWrap = element.querySelector(".swiper-wrapper");
      let carouselItems = JSON.parse(element.dataset.carouselItemsJson);
      swpSlide = swpSlide ? swpSlide.innerHTML : ""
      sortCarousel(carouselItems, element, swpSlide, swpWrap);

      filters.forEach(function (filter) {
        filter.addEventListener('change', function () {
          let filteredItem = '';
          let filterType = filter.dataset.filterType;
          let selectedFilterValue = filter.value;
          const noResults = moduleWrap.querySelector(".js-filter-carousel-andromeda__no-results");
          const countryFilter = moduleWrap.querySelector(".js-carousel-filter--country");
          const cityFilter = moduleWrap.querySelector(".js-carousel-filter--city");
          const cityFilterJson = JSON.parse(cityFilter.dataset.jsonOptions);

          if (noResults) {
            noResults.classList.remove("filter-carousel-andromeda__no-results--show");
          }

          if (filterType) {
            filteredItem = carouselItems.filter(function (item) {
              return selectedFilterValue != ""
                      ? item[filterType] === selectedFilterValue
                      : item[filterType] != selectedFilterValue
            });
          }

          if (filterType == "country_code") {
            cityFilterJson.forEach(function (city) {
              cityFilter.selectedIndex = 0;

              if (city.country_code === selectedFilterValue || selectedFilterValue === "") {
                cityFilter.querySelector(`option[value=${city.city_code}]`).style.display = "block";
              } else {
                cityFilter.querySelector(`option[value=${city.city_code}]`).style.display = "none";
              }
            });
          } else if (filterType == "city_code" && selectedFilterValue === "" && countryFilter) {
            filteredItem = carouselItems.filter(function (item) {
              return countryFilter.value === ""
                      ? item["country_code"] != countryFilter.value
                      : item["country_code"] === countryFilter.value
            });
          }


          if (filteredItem.length === 0 && noResults) {
            noResults.classList.add("filter-carousel-andromeda__no-results--show");
            noResults.style.height = `${swpWrap.clientHeight}px`;
          }
          sortCarousel(filteredItem, element, swpSlide, swpWrap);
        });
      });
    }
  }

  const carousel = document.querySelectorAll('.js-filter-carousel');

  carousel.forEach(function (element) {
    initFilterCarousel(element);
  });
}

export {
  filterCarousel
}
